import React, { useState } from 'react';
import FlexWrapper from '../../../../../../components/FlexWrapper';
import { Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
    clientDataStore,
    createClientDataStore,
    getClientDataStore,
    oneClient,
} from '../../../../../../redux/slices/clientsSlice';
import { toast } from 'react-toastify';
import { useLayoutEffect } from 'react';

export default function UserCommunicationRetentionPage() {
    const dispatch = useDispatch();
    const client = useSelector(oneClient);
    const dataStore = useSelector(clientDataStore);
    const [retentionSendOut, setRetentionSendOut] = useState(false);

    useLayoutEffect(() => {
        setRetentionSendOut(dataStore?.retention_send_out ?? true);
    }, [dataStore?.retention_send_out]);

    const onCheckboxChange = async (isToggled) => {
        setRetentionSendOut(isToggled);
        try {
            await dispatch(
                createClientDataStore({
                    id: client.client_uid,
                    body: {
                        fields: [
                            {
                                key_name: 'retention_send_out',
                                value: isToggled,
                            },
                        ],
                    },
                    collectionName: 'clients',
                }),
            ).unwrap();
            await dispatch(
                getClientDataStore({
                    id: client.client_uid,
                    collectionName: 'clients',
                }),
            ).unwrap();

            toast.success('Changes saved successfully');
        } catch (error) {
            toast.error(error);
        }
    };
    return (
        <div>
            <FlexWrapper align="center">
                <Switch
                    className="details-table__switch--general"
                    checked={retentionSendOut}
                    onChange={onCheckboxChange}
                />
                <span style={{ marginLeft: '10px' }}>Retention send out</span>
            </FlexWrapper>
        </div>
    );
}
